	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ConfigService } from '../ConfigService';

@Injectable()
export class ChecklistTaskService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService,
		private configData: ConfigService
	){
		this.url = urlService.getURL('ChecklistTask');
	}
	loadDueDateTrackers(id: System.Guid): Observable<ePM.Logic.DueDateTracker[]> {
		return this.myBaseService.loadAll(this.url + '/' + (id ?? '') + '/DueDateTrackers');
	}
	loadTasks(id: System.Guid, start: Date, finish: Date): Observable<ePM.Logic.ChecklistTask[]> {
		var urlStr = this.url + '/Search?personID=' + (id || '') + "&start=";
		if (start) {
			urlStr += this.configData.CombineDateAndTime(start, null).toISOString();
		}
		urlStr += "&finish=";
		if (finish) {
			urlStr += this.configData.CombineDateAndTime(finish, null).toISOString();
		}
		return this.myBaseService.loadAll(urlStr);
	}
	loadAllMyTasks(): Observable<ePM.Logic.ChecklistTask[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForChecklist(id: System.Guid) : Observable<ePM.Logic.ChecklistTask[]> {
		return this.myBaseService.loadAll(this.url +'/List/' + id);
	}
	loadAllForReview(id: System.Guid): Observable<ePM.Logic.ChecklistTask[]> {
		return this.myBaseService.loadAll(this.url + '/Review/' + id);
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.save(tempItem, this.url);
	}
	start(id: System.Guid): Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.save(null, this.url+'/Start/' + id);
	}
	saveNotes(id: System.Guid, notes: string): Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.post(notes, this.url + '/SaveNotes/' + id);
	}
	unstart(id: System.Guid): Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.save(null, this.url + '/UnStart/' + id);
	}
	complete(id: System.Guid): Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.save(null, this.url + '/Complete/' + id);
	}
	uncomplete(id: System.Guid): Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.save(null, this.url + '/UnComplete/' + id);
	}

	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.ChecklistTask> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.ChecklistTask>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<ePM.Logic.ChecklistTask[]>{
		return this.myBaseService.loadAll(this.url + '/Search/' + searchTerm);
	}
}
